import React from 'react';
import ReasonsView from './ReasonsView';
import PropTypes from 'prop-types';
import { SFEntityID, starfishMediaType } from 'utils/types';
import { fetchAuthenticatedJSON, apiErrorMessage } from 'utils/request';

export default class ReasonsContainer extends React.Component {

  constructor() {
    super();
    this.state = { hasFetched: false };
  }

  componentDidMount() {
    const URL = `../api/starfish/success-network/connections/${this.props.id}/appointment-reasons`;
    fetchAuthenticatedJSON(URL, {
      method: 'GET',
      headers: {
        'Accept': starfishMediaType('successnetwork')
      }
    })
    .then(({appointmentTypes}) => this.props.onAppointmentTypesFetched(appointmentTypes))
    .catch(e => this.props.onFailure(apiErrorMessage(e)))
    .then(() => this.setState({hasFetched: true}));
  }

  render() {
    return (
      <ReasonsView
        {...this.state}
        appointmentTypes={this.props.appointmentTypes}
        value={this.props.value}
        onReasonSelected={this.props.onReasonSelected}
        connectionName={this.props.connectionName}
      />
    );
  }
}

ReasonsContainer.propTypes = {
  appointmentTypes: PropTypes.array,
  onAppointmentTypesFetched: PropTypes.func.isRequired,
  id: SFEntityID.isRequired,
  connectionName: PropTypes.string.isRequired,
  value: SFEntityID,
  onReasonSelected: PropTypes.func.isRequired,
  onFailure: PropTypes.func.isRequired
};
